<template>
  <div class="container-fluid">
    <!-- BEGIN Overlay Controls !-->
    <input id="overlay-search"
           class="no-border overlay-search bg-transparent"
           placeholder="Rechercher..."
           autocomplete="off"
           spellcheck="false">
    <br>
    <div class="inline-block">
      <search-bar :add-btn="false" :filters="searchBarFilters">
        <select2 slot="agencies"
                 v-if="renderAgenciesFilter"
                 :value="filters.agencies"
                 @input="updateFilter($event, 'agencies')"
                 class="full-width"
                 placeholder="Toutes"
                 multiple
                 :options="selectAgenciesList">
        </select2>
        <select2 slot="with_contract"
                  :value="filters.with_contract"
                  @input="updateFilter($event, 'with_contract')"
                  class="full-width"
                  :allow-clear="true"
                  :options="options.withContractToggle"
                  placeholder="Tous">
        </select2>
        <select2 slot="rbe_status"
                  :value="filters.rbe_status"
                  @input="updateFilter($event, 'rbe_status')"
                  class="full-width"
                  :allow-clear="true"
                  :options="options.selectRbeStatusesList"
                  placeholder="Tous">
        </select2>
        <select2 slot="distribution_methods"
                 :value="filters.distribution_methods"
                 @input="updateFilter($event, 'distribution_methods')"
                 placeholder="Tous"
                 class="full-width"
                 multiple
                 :options="options.distributionMethods">
        </select2>
        <select2 slot="status"
                 :value="filters.status"
                 @input="updateFilter($event, 'status')"
                 placeholder="Tous"
                 class="full-width"
                 :allow-clear="true"
                 :options="selectStatusesList">
        </select2>
        <select2 slot="package"
                 :value="filters.package_reception"
                 class="full-width"
                 @input="updateFilter($event, 'package_reception')"
                 placeholder="Tous"
                 :allow-clear="true"
                 :options="options.toggler">
        </select2>
        <select2 slot="postal"
                 :value="filters.postal"
                 class="full-width"
                 placeholder="Tous"
                 @input="updateFilter($event, 'postal')"
                 :allow-clear="true"
                 :options="options.toggler">
        </select2>
        <select2 slot="mail_blocked"
                 :value="filters.mail_blocked"
                 class="full-width"
                 placeholder="Tous"
                 @input="updateFilter($event, 'mail_blocked')"
                 :allow-clear="true"
                 :options="options.toggler">
        </select2>
        <select2 slot="mail_forwarded"
                 :value="filters.mail_forwarded"
                 class="full-width"
                 placeholder="Tous"
                 @input="updateFilter($event, 'mail_forwarded')"
                 :allow-clear="true"
                 :options="options.toggler">
        </select2>
        <select2 slot="sap_promo_code"
                 :value="filters.sap_promo_code"
                 class="full-width"
                 placeholder="Tous"
                 @input="updateFilter($event, 'sap_promo_code')"
                 :allow-clear="true"
                 :options="selectSapPromoCodes">
        </select2>
      </search-bar>
    </div>
    <!--<div class="inline-block m-l-10">
                              <p class="fs-13">Pressez entrer pour rechercher</p>
                            </div>-->
    <!-- END Overlay Controls !-->
  </div>
</template>

<script>
  import SearchBar from "components/CustomersList/SearchBar"
  import Select2 from "components/Form/Select2"
  import { mapGetters } from "vuex"

  export default {
    data() {
      return {
        filters: {
          agencies: [],
          with_contract: null,
          distribution_methods: [],
          status: "",
          package: null,
          postal: null,
          mail_blocked: null,
          mail_forwarded: null,
          sap_promo_code: "",
        },
        options: {
          distributionMethods: [
            { id: 1, text: "Domiciliation" },
            { id: 2, text: "Location longue-durée" },
          ],
          withContractToggle: [
            { id: 1, text: "Oui" },
            { id: 0, text: "Non" }
          ],
          toggler: [{ id: 1, text: "Oui" }, { id: 0, text: "Non" }],
          selectRbeStatusesList: [
            { id: 'not-concerned', text: 'Non concerné'},
            { id: 'inpi-documents-to-check', text: 'Document(s) INPI à contrôler'},
            { id: 'empty', text: 'Vide'},
            { id: 'update-required', text: 'À mettre à jour'},
            { id: 'validated', text: 'Validé'}
          ]
        },
      }
    },

    components: {
      SearchBar,
      Select2,
    },

    // created() {
    //   const unwatchAgencies = this.$watch(
    //     "userAgenciesIdList",
    //     (list, old) => {
    //       if (old && old.length) return null
    //       this.filters.agencies = [...this.userAgenciesIdList]
    //       this.$nextTick(unwatchAgencies)
    //     },
    //     { immediate: true }
    //   )
    // },

    computed: {
      ...mapGetters("customers", [
        "userAgenciesIdList",
        "selectAgenciesList",
        "selectOrganizationsList",
        "selectStatusesList",
      ]),

      ...mapGetters(["sapPromoCodes"]),

      renderAgenciesFilter() {
        return this.selectAgenciesList.length
      },

      searchBarFilters () {
        let noContract = this.filters.with_contract == 0

        return {
          agencies: !noContract,
          distributionMethods: !noContract,
          contractInstructions: !noContract,
          status: true,
          withContract: true,
          rbeStatus: !noContract,
          sapPromoCode: true
        }
      },

      selectSapPromoCodes() {
        let collection = []
        let obj = {}

        for (let i = 0; i < this.sapPromoCodes.length; i++) {
          obj = {}
          obj['id'] = this.sapPromoCodes[i]
          obj['text'] = this.sapPromoCodes[i]
          collection.push(obj)
        }

        return collection
      }
    },

    methods: {
      updateFilter(values, name) {
        // console.log('name: ' + name + ', values: ' + values)
        this.filters[name] = values

        this.$emit("update:filters", { [name]: values })
      },
    },
  }
</script>

<style>
  .select2-container--open {
    z-index: 9999;
  }
</style>





// WEBPACK FOOTER //
// client/components/SearchOverlay/Controls.vue